// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"4b67131d","453":"2c52a163","806":"12c3fc1d"}[chunkId] + ".chunk.js";
};